export default __webpack_public_path__ + "static/media/aws-ec-2-image-circle.1810ae66.svg";